import React from "react";
import Login from "../../views/auth/Login";

function LoginLayout() {

    return (
      <main className="main" id="top">
        <div className="container-fluid">
          <div className="row min-vh-100 bg-100">
            <div className="col-sm-10 col-md-6 px-sm-0 align-self-center mx-auto py-5">
              <div className="row justify-content-center g-0">
                <div className="col-lg-9 col-xl-8 col-xxl-6">
                  <Login />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    )

}

export default LoginLayout;
